// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  ownerName: __t.option(__t.string()).name("owner_name"),
  ownerEmail: __t.option(__t.string()).name("owner_email"),
  id: __t.string().primaryKey(),
  name: __t.string(),
  enabled: __t.bool(),
  startedAt: __t.option(__t.timestamp()).name("started_at"),
});
